module.exports = __webpack_public_path__ + "static/media/mx.df568fd5.png";